import { getCurrentBuild } from 'web/data/core-data'
import { CLASS_ID, CLASS_META, FIGHT_CATEGORY_ID } from 'web/data/general/id'
import { groupList } from 'web/utils/utils'
import { SelectOptionGroup } from "./models"

function wowheadIconUrl(imgName: string) {
    return `https://wow.zamimg.com/images/wow/icons/large/${imgName}.jpg`
}

export const FightCategoryIcons = {

    [FIGHT_CATEGORY_ID.CUSTOM.Uncategorized]: wowheadIconUrl("inv_misc_questionmark"),

    [FIGHT_CATEGORY_ID.LOU.Vexie]: wowheadIconUrl("inv_111_raid_achievement_vexieandthegeargrinders"),
    [FIGHT_CATEGORY_ID.LOU.Carnage]: wowheadIconUrl("inv_11_arenaboss_colossalclash"),
    [FIGHT_CATEGORY_ID.LOU.Rik]: wowheadIconUrl("inv_111_raid_achievement_rikreverb"),
    [FIGHT_CATEGORY_ID.LOU.Stix]: wowheadIconUrl("inv_111_raid_achievement_stixbunkjunker"),
    [FIGHT_CATEGORY_ID.LOU.Sprocket]: wowheadIconUrl("inv_111_raid_achievement_sprocketmongerlocknstock"),
    [FIGHT_CATEGORY_ID.LOU.Bandit]: wowheadIconUrl("inv_111_raid_achievement_onearmedbandit"),
    [FIGHT_CATEGORY_ID.LOU.Mugze]: wowheadIconUrl("inv_111_raid_achievement_mugzeeheadsofsecurity"),
    [FIGHT_CATEGORY_ID.LOU.Gally]: wowheadIconUrl("inv_111_raid_achievement_chromekinggallywix"),

    [FIGHT_CATEGORY_ID.NP.Ansurek]: wowheadIconUrl("inv_achievement_raidnerubian_queenansurek"),
    [FIGHT_CATEGORY_ID.NP.Court]: wowheadIconUrl("inv_achievement_raidnerubian_council"),
    [FIGHT_CATEGORY_ID.NP.Princess]: wowheadIconUrl("inv_achievement_raidnerubian_etherealassasin"),
    [FIGHT_CATEGORY_ID.NP.Brood]: wowheadIconUrl("inv_achievement_raidnerubian_swarmmother"),
    [FIGHT_CATEGORY_ID.NP.Rash]: wowheadIconUrl("inv_achievement_raidnerubian_flyingnerubianevolved"),
    [FIGHT_CATEGORY_ID.NP.Sikran]: wowheadIconUrl("inv_achievement_raidnerubian_nerubianevolved"),
    [FIGHT_CATEGORY_ID.NP.Horror]: wowheadIconUrl("inv_achievement_raidnerubian_blackblood"),
    [FIGHT_CATEGORY_ID.NP.Ulgrax]: wowheadIconUrl("inv_achievement_raidnerubian_nerubianhulk"),

    [FIGHT_CATEGORY_ID.ADH.Gnarl]: wowheadIconUrl("inv_achievement_raidemeralddream_fieryancient"),
    [FIGHT_CATEGORY_ID.ADH.Igira]: wowheadIconUrl("inv_achievement_raidemeralddream_igira-the-cruel"),
    [FIGHT_CATEGORY_ID.ADH.Volco]: wowheadIconUrl("inv_achievement_raidemeralddream_lavaserpent"),
    [FIGHT_CATEGORY_ID.ADH.Council]: wowheadIconUrl("inv_achievement_raidemeralddream_dreamcouncil"),
    [FIGHT_CATEGORY_ID.ADH.Nymue]: wowheadIconUrl("inv_achievement_raidemeralddream_dreamweaver"),
    [FIGHT_CATEGORY_ID.ADH.Larodar]: wowheadIconUrl("inv_achievement_raidemeralddream_keeperoftheflames"),
    [FIGHT_CATEGORY_ID.ADH.Smolderon]: wowheadIconUrl("inv_achievement_raidemeralddream_smolderon"),
    [FIGHT_CATEGORY_ID.ADH.Tindral]: wowheadIconUrl("inv_achievement_raidemeralddream_druidoftheflame"),
    [FIGHT_CATEGORY_ID.ADH.Fyrakk]: wowheadIconUrl("inv_achievement_raidemeralddream_fyrakk"),

    [FIGHT_CATEGORY_ID.ASC.Kazzara]: wowheadIconUrl("inv_achievement_raiddragon_kazzara"),
    [FIGHT_CATEGORY_ID.ASC.Assault]: wowheadIconUrl("inv_achievement_raiddragon_zaqaliassault"),
    [FIGHT_CATEGORY_ID.ASC.Amalga]: wowheadIconUrl("inv_achievement_raiddragon_amalgamationchamber"),
    [FIGHT_CATEGORY_ID.ASC.Experiments]: wowheadIconUrl("inv_achievement_raiddragon_forgottenexperiments"),
    [FIGHT_CATEGORY_ID.ASC.Rashok]: wowheadIconUrl("inv_achievement_raiddragon_rashok"),
    [FIGHT_CATEGORY_ID.ASC.Zskarn]: wowheadIconUrl("inv_achievement_raiddragon_zskarn"),
    [FIGHT_CATEGORY_ID.ASC.Magmorax]: wowheadIconUrl("inv_achievement_raiddragon_magmorax"),
    [FIGHT_CATEGORY_ID.ASC.Neltharion]: wowheadIconUrl("inv_achievement_raiddragon_neltharion"),
    [FIGHT_CATEGORY_ID.ASC.Sarkareth]: wowheadIconUrl("inv_achievement_raiddragon_sarkareth"),

    [FIGHT_CATEGORY_ID.VOTI.StormEater]: wowheadIconUrl("achievement_raidprimalist_raszageth"),
    [FIGHT_CATEGORY_ID.VOTI.Broodkeeper]: wowheadIconUrl("achievement_raidprimalist_diurna"),
    [FIGHT_CATEGORY_ID.VOTI.Dathea]: wowheadIconUrl("achievement_raidprimalist_windelemental"),
    [FIGHT_CATEGORY_ID.VOTI.Kurog]: wowheadIconUrl("achievement_raidprimalist_kurog"),
    [FIGHT_CATEGORY_ID.VOTI.Spider]: wowheadIconUrl("achievement_raidprimalist_sennarth"),
    [FIGHT_CATEGORY_ID.VOTI.Terros]: wowheadIconUrl("achievement_raidprimalist_terros"),
    [FIGHT_CATEGORY_ID.VOTI.Council]: wowheadIconUrl("achievement_raidprimalist_council"),
    [FIGHT_CATEGORY_ID.VOTI.Eranog]: wowheadIconUrl("achievement_raidprimalist_eranog"),

}

/**
 * Never remove anything from this list, we might still have outlines
 * out there tied to items here. Set `isSelectable` to false if you
 * want to disable creation of new outlines for that boss.
 */
const FightCategoryOptions: SelectOptionGroup[] = [
    {
        label: "Custom",
        isSelectable: true,
        items: [
            {
                value: FIGHT_CATEGORY_ID.CUSTOM.Uncategorized,
                label: "Uncategorized",
            }
        ]
    },
    {
        label: "LOU",
        isSelectable: true,
        items: [
            { value: FIGHT_CATEGORY_ID.LOU.Gally, label: "Gally" },
            { value: FIGHT_CATEGORY_ID.LOU.Mugze, label: "Mugze" },
            { value: FIGHT_CATEGORY_ID.LOU.Bandit, label: "Bandit" },
            { value: FIGHT_CATEGORY_ID.LOU.Sprocket, label: "Sprocket" },
            { value: FIGHT_CATEGORY_ID.LOU.Stix, label: "Stix" },
            { value: FIGHT_CATEGORY_ID.LOU.Rik, label: "Rik" },
            { value: FIGHT_CATEGORY_ID.LOU.Carnage, label: "Carnage" },
            { value: FIGHT_CATEGORY_ID.LOU.Vexie, label: "Vexie" }
        ]
    },
    {
        label: "NP",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.NP.Ansurek, label: "Ansurek" },
            { value: FIGHT_CATEGORY_ID.NP.Court, label: "Court" },
            { value: FIGHT_CATEGORY_ID.NP.Princess, label: "Princess" },
            { value: FIGHT_CATEGORY_ID.NP.Brood, label: "Brood" },
            { value: FIGHT_CATEGORY_ID.NP.Rash, label: "Rash" },
            { value: FIGHT_CATEGORY_ID.NP.Sikran, label: "Sikran" },
            { value: FIGHT_CATEGORY_ID.NP.Horror, label: "Horror" },
            { value: FIGHT_CATEGORY_ID.NP.Ulgrax, label: "Ulgrax" }
        ]
    },
    {
        label: "ADH",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.ADH.Fyrakk, label: "Fyrakk" },
            { value: FIGHT_CATEGORY_ID.ADH.Tindral, label: "Tindral" },
            { value: FIGHT_CATEGORY_ID.ADH.Smolderon, label: "Smolderon" },
            { value: FIGHT_CATEGORY_ID.ADH.Larodar, label: "Larodar" },
            { value: FIGHT_CATEGORY_ID.ADH.Nymue, label: "Nymue" },
            { value: FIGHT_CATEGORY_ID.ADH.Council, label: "Council" },
            { value: FIGHT_CATEGORY_ID.ADH.Volco, label: "Volcoross" },
            { value: FIGHT_CATEGORY_ID.ADH.Igira, label: "Igira" },
            { value: FIGHT_CATEGORY_ID.ADH.Gnarl, label: "Gnarlroot" },
        ]
    },
    {
        label: "ASC",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.ASC.Sarkareth, label: "Sarkareth" },
            { value: FIGHT_CATEGORY_ID.ASC.Neltharion, label: "Neltharion" },
            { value: FIGHT_CATEGORY_ID.ASC.Magmorax, label: "Magmorax" },
            { value: FIGHT_CATEGORY_ID.ASC.Zskarn, label: "Zskarn" },
            { value: FIGHT_CATEGORY_ID.ASC.Rashok, label: "Rashok" },
            { value: FIGHT_CATEGORY_ID.ASC.Assault, label: "Assault" },
            { value: FIGHT_CATEGORY_ID.ASC.Experiments, label: "Experiments" },
            { value: FIGHT_CATEGORY_ID.ASC.Amalga, label: "Amalgamation" },
            { value: FIGHT_CATEGORY_ID.ASC.Kazzara, label: "Kazzara" },
        ]
    },
    {
        label: "VOTI",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.VOTI.StormEater, label: "Raszageth" },
            { value: FIGHT_CATEGORY_ID.VOTI.Broodkeeper, label: "Broodkeeper" },
            { value: FIGHT_CATEGORY_ID.VOTI.Dathea, label: "Dathea" },
            { value: FIGHT_CATEGORY_ID.VOTI.Kurog, label: "Kurog" },
            { value: FIGHT_CATEGORY_ID.VOTI.Spider, label: "Sennarth" },
            { value: FIGHT_CATEGORY_ID.VOTI.Terros, label: "Terros" },
            { value: FIGHT_CATEGORY_ID.VOTI.Council, label: "Council" },
            { value: FIGHT_CATEGORY_ID.VOTI.Eranog, label: "Eranog" },
        ]
    },
    {
        label: "SOFO",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.SOFO.Guardian, label: "Vigilant Guardian" },
            { value: FIGHT_CATEGORY_ID.SOFO.Skolex, label: "Skrillex" /*"Skolex, the Insatiable Ravener"*/ },
            { value: FIGHT_CATEGORY_ID.SOFO.Xymox, label: "Artificer Xy'Mox" },
            { value: FIGHT_CATEGORY_ID.SOFO.Dausegne, label: "The Sausage" /*"Dausegne, the Fallen Oracle"*/ },
            { value: FIGHT_CATEGORY_ID.SOFO.Pantheon, label: "Prototype Pantheon" },
            { value: FIGHT_CATEGORY_ID.SOFO.Lihuvim, label: "Lithium" /*"Lihuvim, Principal Architech"*/ },
            { value: FIGHT_CATEGORY_ID.SOFO.Halondrus, label: "Halondrus the Reclaimer" },
            { value: FIGHT_CATEGORY_ID.SOFO.Anduin, label: "Anduin Wrynn" },
            { value: FIGHT_CATEGORY_ID.SOFO.Malganis, label: "Lords of Dread" },
            { value: FIGHT_CATEGORY_ID.SOFO.Rygelon, label: "Rygelon" },
            { value: FIGHT_CATEGORY_ID.SOFO.Jailer, label: "Jailer" },
        ]
    },
    {
        label: "SOD",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.SOD.Tarra, label: "The Tarragrue" },
            { value: FIGHT_CATEGORY_ID.SOD.Eye, label: "Eye of the Jailer" },
            { value: FIGHT_CATEGORY_ID.SOD.DayNine, label: "The Nine" },
            { value: FIGHT_CATEGORY_ID.SOD.Remnant, label: "Remnant of Ner'zhul" },
            { value: FIGHT_CATEGORY_ID.SOD.Soulrender, label: "Soulrender Dormazain" },
            { value: FIGHT_CATEGORY_ID.SOD.Painsmith, label: "Painsmith Raznal" },
            { value: FIGHT_CATEGORY_ID.SOD.Guardian, label: "Guardian of the First Ones" },
            { value: FIGHT_CATEGORY_ID.SOD.Fatescribe, label: "Fatescribe Roh-Kalo" },
            { value: FIGHT_CATEGORY_ID.SOD.KT, label: "Kel'Thuzad" },
            { value: FIGHT_CATEGORY_ID.SOD.Sylvanis, label: "Sylvanis Windrunner" },
        ]
    },
    {
        label: "CN",
        isSelectable: false,
        items: [
            { value: FIGHT_CATEGORY_ID.CN.Shriekwing, label: "Shriekwing" },
            { value: FIGHT_CATEGORY_ID.CN.Altimor, label: "Huntsman Altimor" },
            { value: FIGHT_CATEGORY_ID.CN.Hungering, label: "Hungering Destroyer" },
            { value: FIGHT_CATEGORY_ID.CN.Artificer, label: "Artificer Xy'Mox" },
            { value: FIGHT_CATEGORY_ID.CN.SunKing, label: "Sun King's Salvation" },
            { value: FIGHT_CATEGORY_ID.CN.Darkvein, label: "Lady Inerva Darkvein" },
            { value: FIGHT_CATEGORY_ID.CN.Council, label: "The Council of Blood" },
            { value: FIGHT_CATEGORY_ID.CN.Sludgefist, label: "Sludgefist" },
            { value: FIGHT_CATEGORY_ID.CN.Stoneborne, label: "Stone Legion Generals" },
            { value: FIGHT_CATEGORY_ID.CN.Denathrius, label: "Sire Denathrius" },
        ]
    },
]

const PlayerSpecOptions: SelectOptionGroup[] = []

const specs = Object.values(getCurrentBuild().specsById)

const groupedSpecs = groupList(specs, (item) => item.classId)

Object.values(CLASS_ID).forEach(classId => {
    const classMeta = CLASS_META[classId]
    const specList = groupedSpecs.get(classId)

    // Don't list classes without specs
    if (specList.length <= 0) {
        return
    }

    PlayerSpecOptions.push({
        label: classMeta.name,
        items: specList.map(spec => ({
            label: spec.name,
            value: spec.id,
        })),
        isSelectable: true
    })
})

export const GuiData = {
    FightCategoryOptions,
    PlayerSpecOptions,
}

export function getFightCategoryLabelById(categoryId: string): string {
    let label = ""

    FightCategoryOptions.forEach(opt => {
        opt.items.forEach(item => {
            if (item.value === categoryId) {
                label = item.label
            }
        })
    })

    return label
}
